<template>
    <div class="footer">
		<div class="flex align-center justify-center">
			<div class="flex align-center justify-center">
				<div class="tital flex align-center justify-center">
				    <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2020036138号-6技术支持：四川释参信息科技有限公司</a>
				</div>
				<img src="../../assets/img/beian.png" alt="" />
			</div>
			
		</div>
       
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {};
    }
};
</script>
<style scoped lang="scss">
.footer {
    z-index: 2;
    width: 100%;
    height: 42px;
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    background: #333333;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 14px;
    color: #FFFFFF;
    box-sizing: border-box;
    .tital {
        box-sizing: border-box;
        a {
            padding-right: 15px;
			font-size: 14px;
			 color: #FFFFFF;
        }
    }
    img {
        width: 62px;
		height: 31px;
    }
}
</style>
